export const getIsActiveNumeric = (active: { value: string | number; label: string }[]) => {
  if (!active.length || active.length > 1) return undefined;

  if (+active[0]?.value > 1 ) return undefined 

  return +active[0]?.value;
}